var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54167 14.875C3.15208 14.875 2.81563 14.7392 2.53229 14.4677C2.26076 14.1844 2.125 13.8479 2.125 13.4583V3.54167C2.125 3.15208 2.26076 2.82153 2.53229 2.55C2.81563 2.26667 3.15208 2.125 3.54167 2.125H13.4583C13.8479 2.125 14.1785 2.26667 14.45 2.55C14.7333 2.82153 14.875 3.15208 14.875 3.54167V13.4583C14.875 13.8479 14.7333 14.1844 14.45 14.4677C14.1785 14.7392 13.8479 14.875 13.4583 14.875H3.54167ZM3.54167 13.4583H13.4583V3.54167H3.54167V13.4583ZM4.25 12.0417H12.75L10.0938 8.5L7.96875 11.3333L6.375 9.20833L4.25 12.0417ZM3.54167 13.4583V3.54167V13.4583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSelected);
export default __webpack_public_path__ + "static/media/image-selected.d60a7a0c00c2d15a264a33ea513e248f.svg";
export { ForwardRef as ReactComponent };